import classnames from "classnames";
import {
  DashboardIcon,
  LogOutIcon,
  ReportsIcon,
  RfqIcon,
  RfqNotificationsIcon,
  SettingsIcon,
  SubmenuArrow,
  TrucksIcon,
} from "components/assets/Icons";
import { Logo, SmallLogo } from "components/Logo/Logo";
import { useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { API_HOST } from "utils/constants";
import styles from "./Toolbar.module.scss";

const dropdownReportsMenu = [
  {
    linkName: "CALLS",
    linkPath: "/calls",
  },
  {
    linkName: "WORKING HOURS",
    linkPath: "/working-hours",
  },
  {
    linkName: "COMMISSIONS CHECK",
    linkPath: `${API_HOST}/xlsx_parser`,
    target: "_blank",
    rel: "noopener noreferrer nofollow",
  },
  {
    linkName: "Employee info",
    linkPath: "/completeness_info",
  },
];

const dropdownSettingsMenu = [
  {
    linkName: "DATA UPDATE",
    linkPath: "/data-update",
  },
  {
    linkName: "PROFILE",
    linkPath: "/profile",
  },
];

const dropdownRFQMenu = [
  {
    linkName: "All",
    linkPath: "/request_for_quote_page",
    dispatched: false,
  },
  {
    linkName: "Dispatched trucks",
    linkPath: "/request_for_quote_page",
    dispatched: true,
  },
  {
    linkName: "List",
    linkPath: "/request_for_quote_page_list",
    dispatched: null,
  },
];

const dropdownRFQNotificationsMenu = [
  {
    linkName: "MANAGE RULES",
    linkPath: "/rfq-notifications/manage-rules",
  },
  {
    linkName: "CONTACT BLACKLIST", 
    linkPath: "/rfq-notifications/contact-blacklist",
  },
];

const Toolbar = ({ logOut, permissions }) => {
  const refReport = useRef();
  const refSettings = useRef();
  const refRfq = useRef();
  const refRfqNotifications = useRef();
  const refHeader = useRef();

  const [dropdownReports, setDropdownReports] = useState(false);
  const [dropdownSettings, setDropdownSettings] = useState(false);
  const [rfqSettings, setRfqSettings] = useState(false);
  const [dropdownRfqNotifications, setDropdownRfqNotifications] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <header
      className={styles.header}
      ref={refHeader}
      onMouseLeave={() => {
        setDropdownReports(false);
        setDropdownSettings(false);
        setRfqSettings(false);
        setDropdownRfqNotifications(false);
      }}
    >
      <div className={styles.container}>
        <Link to="/">
          <div className={styles.logo}>
            <div className={styles.logo_icon}>
              {" "}
              <SmallLogo />{" "}
            </div>
            <div className={styles.logo_big}>
              <Logo className={styles.label} />
            </div>
          </div>
        </Link>
        <nav className={styles.wrapper}>
          <ul className={styles.menu}>
            {(permissions?.calls ||
              permissions?.calls_and_tracking ||
              permissions?.working_hours ||
              permissions?.commissions_check ||
              permissions?.completeness_info) && (
              <li className={styles.menu_item} ref={refReport}>
                <Link to="/">
                  <button
                    className={classnames(
                      styles.menu_button,
                      styles.menu_dashboard,
                      isActive("/") && styles.active,
                    )}
                  >
                    <div className={classnames(styles.menu_icon)}>
                      <DashboardIcon />
                    </div>
                    <span className={styles.label}>Dashboard</span>
                  </button>
                </Link>
              </li>
            )}
            {(permissions?.calls ||
              permissions?.calls_and_tracking ||
              permissions?.working_hours ||
              permissions?.commissions_check ||
              permissions?.completeness_info) && (
              <li className={styles.menu_item} ref={refReport}>
                <button
                  id="reports"
                  className={classnames(
                    styles.menu_button,
                    (isActive("/calls") ||
                      isActive("/tracking") ||
                      isActive("/working-hours") ||
                      isActive("/completeness_info")) &&
                      styles.active,
                  )}
                  onClick={() => {
                    setDropdownReports((prev) => !prev);
                  }}
                >
                  <div className={styles.menu_icon}>
                    <ReportsIcon />
                  </div>

                  <span className={styles.label}>
                    Reports{" "}
                    <span
                      className={classnames(
                        styles.arrow,
                        dropdownReports ? styles.arrow_up : styles.arrow_down,
                      )}
                    >
                      <SubmenuArrow />
                    </span>
                  </span>
                </button>
                <ul
                  className={classnames(styles.submenu, dropdownReports && styles.show)}
                >
                  {dropdownReportsMenu.map(
                    ({ linkName, linkPath, target, rel }, index) => {
                      if (linkName === "CALLS" && !permissions?.calls) {
                        return null;
                      } else if (
                        linkName === "Calls & Tracking" &&
                        !permissions?.calls_and_tracking
                      ) {
                        return null;
                      } else if (
                        linkName === "WORKING HOURS" &&
                        !permissions?.working_hours
                      ) {
                        return null;
                      } else if (
                        linkName === "COMMISSIONS CHECK" &&
                        !permissions?.commissions_check
                      ) {
                        return null;
                      } else if (
                        linkName === "Employee info" &&
                        !permissions?.completeness_info
                      ) {
                        return null;
                      } else {
                        return (
                          <li
                            className={classnames(styles.submenu_item, styles.item)}
                            key={linkName + index}
                          >
                            <Link
                              to={linkPath}
                              onClick={() => setDropdownReports(false)}
                              className={classnames(styles.submenu_link, styles.link)}
                              target={target}
                              rel={rel}
                            >
                              {linkName.toLowerCase()}
                            </Link>
                          </li>
                        );
                      }
                    },
                  )}
                </ul>
              </li>
            )}

            {(permissions?.rfq_all_trucks || permissions?.rfq_dispatched_trucks) && (
              <li className={styles.menu_item} ref={refRfq}>
                <button
                  id="rfqsettings"
                  className={classnames(
                    styles.menu_button,
                    (isActive("/request_for_quote_page") ||
                      isActive("/request_for_quote_page_list")) &&
                      styles.active,
                  )}
                  onClick={() => {
                    setRfqSettings((prev) => !prev);
                  }}
                >
                  <div className={styles.menu_icon}>
                    {" "}
                    <RfqIcon />
                  </div>
                  <span className={styles.label}>
                    RfQ{" "}
                    <span
                      className={classnames(
                        styles.arrow,
                        rfqSettings ? styles.arrow_up : styles.arrow_down,
                      )}
                    >
                      <SubmenuArrow />
                    </span>
                  </span>
                </button>
                <ul className={classnames(styles.submenu, rfqSettings && styles.show)}>
                  {dropdownRFQMenu.map(
                    ({ linkName, linkPath, target, rel, dispatched }, index) => {
                      let state = { dispatched: dispatched };
                      if (linkName === "All" && !permissions?.rfq_all_trucks) {
                        return null;
                      } else if (
                        linkName === "Dispatched trucks" &&
                        !permissions?.rfq_dispatched_trucks
                      ) {
                        return null;
                      } else if (linkName === "List" && !permissions?.rfq_list) {
                        return null;
                      } else {
                        return (
                          <li
                            className={classnames(styles.submenu_item, styles.item)}
                            key={linkName + index}
                          >
                            <Link
                              to={linkPath}
                              state={state}
                              onClick={() => setRfqSettings(false)}
                              className={classnames(styles.submenu_link, styles.link)}
                              target={target}
                              rel={rel}
                            >
                              {linkName}
                            </Link>
                          </li>
                        );
                      }
                    },
                  )}
                </ul>
              </li>
            )}

            {permissions?.manage_dispatched_trucks && (
              <li className={styles.menu_item}>
                <Link
                  to="/trucks"
                  className={classnames(
                    styles.menu_link,
                    isActive("/trucks") && styles.active,
                  )}
                >
                  <div className={styles.menu_icon}>
                    <TrucksIcon />
                  </div>
                  <span className={styles.label}>Trucks</span>
                </Link>
              </li>
            )}

            {(permissions?.rfq_notification?.manage_rfq_notifications || permissions?.rfq_notification?.manage_rfq_contact_blacklist) && (
              <li className={styles.menu_item} ref={refRfqNotifications}>
                <button
                  id="rfq-notifications"
                  className={classnames(
                    styles.menu_button,
                    (location.pathname.startsWith("/rfq-notifications")) && styles.active,
                  )}
                  onClick={() => {
                    setDropdownRfqNotifications((prev) => !prev);
                  }}
                >
                  <div className={styles.menu_icon}>
                    <RfqNotificationsIcon />
                  </div>

                  <span className={styles.label}>
                    RFQ Notifications{" "}
                    <span
                      className={classnames(
                        styles.arrow,
                        dropdownRfqNotifications ? styles.arrow_up : styles.arrow_down,
                      )}
                    >
                      <SubmenuArrow />
                    </span>
                  </span>
                </button>
                <ul
                  className={classnames(styles.submenu, dropdownRfqNotifications && styles.show)}
                >
                  {dropdownRFQNotificationsMenu.map(({ linkName, linkPath }, index) => {
                    if (linkName === "MANAGE RULES" && !permissions?.rfq_notification?.manage_rfq_notifications) {
                      return null;
                    } else if (linkName === "CONTACT BLACKLIST" && !(
                      permissions?.rfq_notification?.manage_rfq_notifications || 
                      permissions?.rfq_notification?.manage_rfq_contact_blacklist
                    )) {
                      return null;
                    } else {
                      return (
                        <li
                          className={classnames(styles.submenu_item, styles.item)}
                          key={linkName + index}
                        >
                          <Link
                            to={linkPath}
                            onClick={() => setDropdownRfqNotifications(false)}
                            className={classnames(styles.submenu_link, styles.link)}
                          >
                            {linkName.toLowerCase()}
                          </Link>
                        </li>
                      );
                    }
                  })}
                </ul>
              </li>
            )}

            {(permissions?.profile || permissions?.data_update) && (
              <li className={`${styles.menu_item} ${styles.settings_menu_item}`} ref={refSettings}>
                <button
                  id="settings"
                  className={classnames(
                    styles.menu_button,
                    (isActive("/data-update") || isActive("/profile")) && styles.active,
                  )}
                  onClick={() => {
                    setDropdownSettings((prev) => !prev);
                  }}
                >
                  <div className={styles.menu_icon}>
                    <SettingsIcon />
                  </div>

                  <span className={styles.label}>
                    Settings{" "}
                    <span
                      className={classnames(
                        styles.arrow,
                        dropdownSettings ? styles.arrow_up : styles.arrow_down,
                      )}
                    >
                      <SubmenuArrow />
                    </span>
                  </span>
                </button>
                <ul
                  className={classnames(styles.submenu, dropdownSettings && styles.show)}
                >
                  {dropdownSettingsMenu.map(({ linkName, linkPath }, index) => {
                    if (linkName === "DATA UPDATE" && !permissions?.data_update) {
                      return null;
                    } else if (linkName === "PROFILE" && !(
                      permissions?.profile?.my_info ||
                      permissions?.profile?.teams ||
                      permissions?.profile?.team_members ||
                      permissions?.profile?.schedules ||
                      permissions?.profile?.settings
                    )) {
                      return null;
                    } else {
                      return (
                        <li
                          className={classnames(styles.submenu_item, styles.item)}
                          key={linkName + index}
                        >
                          <Link
                            to={linkPath}
                            onClick={() => setDropdownSettings(false)}
                            className={classnames(styles.submenu_link, styles.link)}
                          >
                            {linkName.toLowerCase()}
                          </Link>
                        </li>
                      );
                    }
                  })}
                </ul>
              </li>
            )}

            <li className={styles.menu_item}>
              <a href="/login" className={styles.menu_link} onClick={logOut}>
                <div className={styles.menu_icon}>
                  <LogOutIcon />
                </div>
                <span className={styles.label}>Log out</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Toolbar;
